<template>
  <mdc-dialog class="bids-modal"
              v-model="isOpen"
              :title="'bids.edit_bid' | trans"
              @accept="close"
              @close="close"
              @cancel="cancel"
              @validate="validate">

    <div class="close-cross" @click="cancel()">
      <mdc-icon icon="close"></mdc-icon>
    </div>

    <form enctype="multipart/form-data" novalidate>
      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="goal"
                         :label="'bids.protocol_goal' | trans"
                         type="text"
                         name="goal"
                         :class="{'is-invalid': errors.has('goal')}"
                         v-validate="'required|min:10|max:1000'"
                         v-model="bid.description"
                         data-vv-validate-on="none"
                         :data-vv-as="'bids.protocol_goal' | trans"/>

          <span class="invalid-feedback"
                v-if="errors.has('goal')">
            <strong>{{ errors.first('goal') }}</strong>
          </span>
        </div>
      </div>

      <div class="form-group row" v-if="!isTherapist">
        <div class="col-md-12">

          <select-with-pager id="entities"
                             name="entities"
                             class="load_more__select aut-dropdown"
                             :label="'name'"
                             :selected=protocol
                             :options="entities"
                             :searchable="true"
                             :loading=loading
                             :isLastPage=isLastPage
                             v-on:next-page="nextPage"
                             v-on:set-selected="onChangeProcol"
                             v-on:set-search="onSearchProcol"
                             v-bind:getOptionTitle="getOptionTitle"
                             v-bind:isLast="isLast"
                             :validated=validated
                             :noOptions="'bids.type_the_procol_name_to_search' | trans"
          >

          </select-with-pager>


          <label class="mdc-floating-label" :class="{ 'mdc-floating-label-error': errors.has('protocol') }">{{ 'bids.appoint_protocol' | trans }}</label>
          <span class="description-row">{{'bids.start_protocol' | trans }}</span>
        </div>
        <div class="col-md-12">
                        <span class="invalid-feedback-label" v-if="errors.has('protocol')">
                            <strong>{{ errors.first('protocol') }}</strong>
                        </span>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <mdc-textfield id="comment"
                         :label="'bids.add_comment' | trans"
                         type="text"
                         name="comment"
                         :class="{'is-invalid': errors.has('comment')}"
                         v-validate="'max:255'"
                         v-model="comment"
                         data-vv-validate-on="none"
                         :data-vv-as="'bids.add_comment' | trans"/>

          <span class="invalid-feedback"
                v-if="errors.has('comment')">
            <strong>{{ errors.first('comment') }}</strong>
          </span>
        </div>
      </div>
    </form>

    <div class="form-group row">
      <div class="col-md-12">
        <div class="text-block" v-if="bid.comments != null && bid.comments.count > 0">
          <p class="text-block__title">{{'bids.comments' | trans}}</p>
          <div v-for="commentary in bid.comments.data">
            <p class="text-block__subtitle">
              {{commentary.user.name}}
            </p>

            <p class="text-block__text">
              {{commentary.text}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <footer class="mdc-dialog__footer mdc-dialog__footer--visible">
      <button type="button" class="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel" @click="cancel"> {{'bids.buttons.cancel' | trans}}</button>

      <router-link class="btn btn-info" v-if="!isTherapist" :to="{ name: 'protocol-create'}">
        {{'bids.buttons.createProtocol' | trans}}
      </router-link>

      <button type="button" class="btn btn-primary" v-if="!isTherapist" @click="onAppointProtocolButtonClick()">{{'bids.buttons.appointProtocol' | trans}}</button>

      <button type="button" class="btn btn-primary" v-if="isCurator || isTherapist" @click="onApprovalButtonClick()">
        <span v-if="isTherapist">{{'bids.buttons.sendRequest' | trans}}</span>
        <span v-else>{{'bids.buttons.submit_for_approval_to_bsba' | trans}}</span>
      </button>
    </footer>
  </mdc-dialog>


</template>

<script>
  import apiBids from '../api/bids';
  import {mapActions, mapGetters} from 'vuex';
  import isEmpty from 'lodash/isEmpty';
  import isObject from 'lodash/isObject';
  import debounce from 'lodash/debounce';
  import selectWithPager from '../../../common/selectWithPager/components/SelectWithPager';

  export default {
    name: 'BidsModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'data': {
        type: Object,
        default() {
          return {};
        },
      },
    },

    data() {
      return {
        bid: [],
        entities: [],
        protocol: '',
        comment: '',
        approval: false,
        perPage: 10,
        page: 1,
        search: "",
        loading: false,
        isLastPage: false,
        validated: {
          validate: this.approval ? '' : 'required',
          on: 'none',
          name: 'protocol',
          as: "'bids.appoint_protocol' | trans"
        }
      };
    },

    components: {
      selectWithPager
    },

    created() {
    },

    methods: {
      ...mapActions('bids/list', [
        'setIsSaved',
      ]),

      async onSearchProcol(search) {
        this.page = 1;
        await this.searchProcol(apiBids, search, this);
      },

      searchProcol: debounce(
          async(apiManager, search, vm) => {
            try {
              let response = await apiManager.searchId(vm.bid.id, search, vm.perPage, vm.page);
              if (response.data.data.items.length){
                vm.entities = response.data.data.items;
                vm.search = search;
                vm.lastId = vm.entities[vm.entities.length - 1].id;

                if(response.data.data.hasMorePages){
                  vm.page++;
                  vm.isLastPage = false;
                } else {
                  vm.isLastPage = true;
                }
              }
            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          150,
      ),



      onChangeProcol(val) {
        this.protocol = val;
      },

      getOptionTitle: function ({option}) {
        return option.name;
      },
      isLast: function ({option}) {
        return option.id == this.lastId;
      },

      nextPage: async function () {
        if (!this.isLastPage) {
          this.loading = true;
          let response = await apiBids.searchId(this.bid.id, this.search, this.perPage, this.page);

          response.data.data.items.forEach((item) => {
            this.entities.push(item)
          });

          this.loading = false;
          this.lastId = this.entities[this.entities.length - 1].id;
          if (response.data.data.lastPage != this.page) {
            this.page++;
          } else {
            this.isLastPage = true;
          }
        }
      },

      onAppointProtocolButtonClick() {
        this.validate();
      },

      onApprovalButtonClick() {
        this.approval = true;
        this.$nextTick(() => {
          this.validate();
        });
      },

      appointProtocol: debounce(
          async(apiManager, vm) => {
            try {
              let response = await apiManager.assign(
                  vm.bid.id,
                  vm.protocol.id,
                  vm.protocol.type,
                  vm.comment,
                  vm.bid.description
              );

              vm.close();
              vm.$parent.onPaginationClick(1);
            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          100,
      ),

      approvalBid: debounce(
          async(apiManager, vm) => {
            try {
              let response = await apiManager.update(
                  vm.bid.id,
                  vm.bid.description,
                  vm.comment
              );

              vm.close();
              vm.$parent.onPaginationClick(1);
            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          100,
      ),

      isNewBid(){
        return this.bid.status.id == 1;
      },

      async validate() {
        let result = await this.$validator.validateAll();

        if (result) {
          if (this.approval) {
            this.approvalBid(apiBids, this);
          }
          else {
            this.appointProtocol(apiBids, this);
          }
        }
      },

      reset() {
        Object.assign(this.$data, this.$options.data());
        this.errors.clear();
      },

      async close() {
        if (this.isTherapist && this.isNewBid()){
          try {
            let response = await apiBids.viewed(
                this.bid.id
            );
          } catch (e) {
            console.error('Unknown API error occurred.');
          } finally {
            this.reset();
            this.setIsSaved(true);
            this.$emit('close');
          }
        } else{
          this.reset();
          this.setIsSaved(true);
          this.$emit('close');
        }
      },


      cancel() {
        this.reset();
        this.$emit('cancel');
      },
    },

    computed: {
      isEdit(){
        return !isEmpty(this.data);
      },
      isOpen: {
        get(){
          return this.visible;
        },
        set(){
        }
      },
      ...mapGetters('auth', [
        'isTherapist',
        'isCurator',
      ])
    },

    watch: {
      visible(){
        if (this.isEdit) {
          if (this.data.item && isObject(this.data)) {
            try {
              this.bid = this.data.item;
              this.onSearchProcol(" ")
            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          }
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/bids/components/Modal.vue